import dashboard from './dashboard';
import recordings from './recordings';
import websocket from './websocket';

const menuItems = {
  items: [dashboard, recordings, websocket],
};

export default menuItems;
